<template>
  <div class="parentWrapper">
    <div v-if="firstLoading" class="emptyWrapper">
      <v-progress-circular
        :size="40"
        :width="3"
        color="#787ff7"
        indeterminate
      ></v-progress-circular>
    </div>
    <div
      v-else-if="list.length == 0 && !searchingFromField"
      class="emptyWrapper d-flex flex-column"
    >
      <div class="folderIconWrapper">
        <NewFolderIcon />
      </div>
      <div class="emptyTitle">Хоосон байна</div>
      <div class="emptyInfo">Та хавтас үүсгэж аудио бичвэрээ хөрвүүлнэ үү</div>
      <v-dialog v-model="dialog" persistent max-width="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="showDialogBtn" v-bind="attrs" v-on="on">
            <div style="margin-right: 5px">
              <NewAddFolderIcon />
            </div>
            Хавтас үүсгэх
          </v-btn>
        </template>
        <v-card class="dialogWrapper">
          <div class="dialogTitleWrapper">
            <div class="folderIconWrapper">
              <NewAddFolderIcon />
            </div>
            <div class="dialogTitle">Хавтас үүсгэх</div>
          </div>
          <div class="dialogWarn">Хавтасны нэрийг оруулна уу</div>
          <div class="createInputWrapper">
            <input
              type="text"
              autocomplete="off"
              placeholder="Миний хавтас"
              name="createProject"
              v-model="folderName"
            />
            <span v-if="inputError == true" class="ff-errorInput">{{
              inputErrorText
            }}</span>
          </div>
          <div class="dialogActionWrapper">
            <v-btn color="darken-1" class="closeBtn" text @click="closeDialog"
              >хаах</v-btn
            >
            <v-btn
              class="createBtn"
              text
              @click="createGroup"
              :loading="this.convertLoading"
              >үүсгэх</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
      <div class="emptyDescWrapper">
        <div class="quizTitleWrapper">
          <QuizIcon />
          <div class="quizStyle">Хавтас гэж юу вэ?</div>
        </div>
        <div class="quizDesc">
          Бүлэг файлуудыг ямаг нэг шинжээр нь нэгтгэн нэр өгснийг хавтас гэнэ.
          Энэ нь мэдээллийг цэгцтэй хадгалах, файл хайх үйл ажиллагааг түргэн
          гүйцэтгэхэд дөхөм болдог.
        </div>
      </div>
    </div>
    <div v-else class="wrapper d-flex flex-column">
      <div class="projectsHeadWrapper">
        <div class="projectsTitle">Таны хавтаснууд</div>
        <div class="projectsHeadRightWrapper">
          <v-dialog v-model="dialog" persistent max-width="500">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="showDialogBtn" v-bind="attrs" v-on="on">
                <div style="margin-right: 5px">
                  <NewAddFolderIcon />
                </div>
                Хавтас үүсгэх
              </v-btn>
            </template>
            <v-card class="dialogWrapper">
              <div class="dialogTitleWrapper">
                <div class="folderIconWrapper">
                  <NewFolderIcon />
                </div>
                <div class="dialogTitle">Хавтас үүсгэх</div>
              </div>
              <div class="dialogWarn">Хавтасны нэрийг оруулна уу</div>
              <div class="createInputWrapper">
                <input
                  type="text"
                  autocomplete="off"
                  placeholder="Миний хавтас"
                  name="createProject"
                  v-model="folderName"
                />
                <span v-if="inputError == true" class="ff-errorInput">{{
                  inputErrorText
                }}</span>
              </div>
              <div class="dialogActionWrapper">
                <v-btn
                  color="darken-1"
                  class="closeBtn"
                  text
                  @click="closeDialog"
                  >хаах</v-btn
                >
                <v-btn
                  class="createBtn"
                  text
                  @click="createGroup"
                  :loading="this.convertLoading"
                  >үүсгэх</v-btn
                >
              </div>
            </v-card>
          </v-dialog>
          <SearchField
            :searchFolder="searchFolder"
            :clearedField="clearedField"
          />
        </div>
      </div>
      <div class="flex-column">
        <div v-if="loading" class="loadingWrapper">
          <v-progress-circular
            :size="40"
            :width="3"
            color="#787ff7"
            indeterminate
          ></v-progress-circular>
        </div>
        <FoldersTable
          v-else
          v-bind:folders="list"
          :updateList="getGroupList"
          whereToOpen="fileFolderDetails"
          ><NewFolderIcon
        /></FoldersTable>
        <div v-if="list.length > 0" class="paginationWrapper">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="6"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            color="#787ff7"
            circle
            @input="nextPage"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import SearchField from "../components/SearchField";
import NewFolderIcon from "../components/icons/NewFolderIcon";
import NewAddFolderIcon from "../components/icons/NewAddFolderIcon";
import QuizIcon from "../components/icons/QuizIcon";
import FoldersTable from "../components/FoldersTable";
import { mapActions, mapState } from "vuex";
export default {
  name: "FileFolders",
  components: {
    NewFolderIcon,
    NewAddFolderIcon,
    QuizIcon,
    FoldersTable,
    SearchField,
  },
  data: () => ({
    dialog: false,
    folderName: "",
    list: [],
    token: null,
    count: 0,
    page: 1,
    pageCount: 0,
    totalProjects: 0,
    itemsPerPage: 8,
    convertLoading: false,
    loading: true,
    firstLoading: true,
    inputErrorText: "",
    inputError: false,
    searchingFromField: false,
  }),
  computed: {
    ...mapState(["allPlan", "customerPlan"]),
    getToken: function() {
      return this.$cookie.get("token");
    },
  },
  mounted() {
    this.getGroupList();
  },
  watch: {
    folderName: function() {
      this.inputValidate();
    },
  },
  methods: {
    ...mapActions([
      "showErrorMessage",
      "showSuccessMessage",
      "showWarningMessage",
      "checkError",
      "setWarningFileDialog",
    ]),
    getGroupList() {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/v2/group?type=file&page=${this.page}&per_page=${this.itemsPerPage}`,
          {
            headers,
          }
        )
        .then((response) => {
          if (response.data.data.Count != 0) {
            this.list = response.data.data.List;
            this.totalProjects = response.data.data.Count;
            this.pageCount = Math.ceil(
              response.data.data.Count / this.itemsPerPage
            );
          } else {
            this.list = [];
          }
          this.loading = false;
          this.firstLoading = false;
          this.searchingFromField = false;
        })
        .catch((error) => {
          this.loading = false;
          this.searchingFromField = false;
          this.checkError(error);
        });
    },
    nextPage(page) {
      this.page = page;
      this.loading = true;
      this.getGroupList();
    },
    createGroup() {
      if (this.inputValidate()) {
        const headers = {
          token: this.getToken,
        };
        this.convertLoading = true;
        axios
          .post(
            `${process.env.VUE_APP_BASE_URL}/v2/group`,
            { name: this.folderName, type: "file" },
            { headers }
          )
          .then((response) => {
            if (this.list.length == this.itemsPerPage) {
              var moveArray = this.list;
              moveArray.pop();
              this.list = [response.data.data, ...moveArray];
            } else {
              this.list = [response.data.data, ...this.list];
            }
            this.totalProjects++;
            this.pageCount = Math.ceil(
              (this.totalProjects + 1) / this.itemsPerPage
            );

            this.showSuccessMessage({
              message: "Хавтас амжилттай үүслээ",
              timeout: 3000,
            });
            this.closeDialog();
          })
          .catch(() => {
            this.showSuccessMessage({
              message: "Хавтас үүсэхэд алдаа гарлаа",
              timeout: 3000,
            });
            this.closeDialog();
          });
      }
    },

    clearedField() {
      this.getGroupList();
    },

    searchFolder(word) {
      const headers = {
        token: this.getToken,
      };
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/v2/group?type=text&page=${this.page}&per_page=${this.itemsPerPage}&order_by=item_number&name=${word}`,
          {
            headers,
          }
        )
        .then((response) => {
          if (response.data.data.Count != 0) {
            this.list = response.data.data.List;
            this.totalProjects = response.data.data.Count;
            this.pageCount = Math.ceil(
              response.data.data.Count / this.itemsPerPage
            );
          } else {
            this.list = [];
          }
          this.loading = false;
          this.searchingFromField = true;
        })
        .catch((error) => {
          this.loading = false;
          this.checkError(error);
        });
    },

    closeDialog() {
      this.convertLoading = false;
      this.folderName = "";
      this.dialog = false;
      this.inputError = false;
    },

    /* Тухайн эдитор дээр оруулсан зүйлүүдийг шалгах функц */
    inputValidate() {
      if (this.folderName.length == 0) {
        this.inputErrorText = "Нэрээ оруулна уу";
        this.inputError = true;
        return false;
      } else if (this.folderName.length > 50) {
        this.inputErrorText = "Нэр 50-н тэмдэгтээс бага байх ёстой";
        this.inputError = true;
        return false;
      } else {
        this.inputError = false;
        return true;
      }
    },
  },
};
</script>
<style scoped>
.loadingWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 541px;
  margin-bottom: 20px;
}

.parentWrapper {
  display: flex;
  height: auto;
  width: 100%;
  position: relative;
  padding-bottom: 20px;
}

.wrapper {
  display: flex;
  height: auto;
  width: 100%;
  position: relative;
}

.emptyWrapper {
  display: flex;
  height: auto;
  width: 100%;
  position: relative;
  align-items: center;
  justify-content: center;
}

.projectsHeadWrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.projectsTitle,
.emptyTitle {
  font-weight: 700;
  text-align: left;
  line-height: 23px;
  font-size: 20px;
  color: #000000;
  margin-bottom: 5px;
}

.emptyTitle {
  width: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.emptyInfo {
  color: #767676;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 30px;
}

.emptyDescWrapper {
  display: flex;
  flex-direction: column;
  width: 350px;
  border-radius: 6px;
  border: 2px solid #e5e5e5;
  padding: 20px;
  margin-top: 30px;
}

.quizTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.quizStyle {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #231f20;
  margin-left: 10px;
}

.quizDesc {
  font-size: 14px;
  color: #767676;
  text-align: justify;
}

.projectsHeadRightWrapper {
  display: flex;
  flex-wrap: wrap;
  /* align-items: center;
  justify-content: center; */
  margin-bottom: 10px;
}

.position {
  text-align: right;
}

.showDialogBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 20px;
  margin-bottom: 5px;
  height: 40px !important;
  width: 155px;
}

.ff-errorInput {
  font-size: 12px;
  line-height: 14px;
  color: red;
  margin: 2px 0 0 10px;
}

.paginationWrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.dialogWrapper {
  padding: 31px 38px;
}

@media screen and (max-width: 768px) {
  .dialogWrapper {
    padding: 20px;
  }
}

.dialogTitleWrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.folderIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  background-color: #eff0fd;
  border-radius: 3px;
  margin-right: 10px;
}

.dialogTitle {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}

.dialogWarn {
  font-size: 14px;
  font-weight: 500;
  color: #767676;
  margin-bottom: 10px;
}

.createInputWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 56px;
}
.createInputWrapper input[type="text"] {
  height: 40px !important;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 14px;
  font-weight: 400;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.createInputWrapper input[type="text"]:focus {
  border: 2px solid #777ff6 !important;
  outline: none;
}

.createInputWrapper input[type="text"]:hover {
  border: 2px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.dialogActionWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 15px;
  height: 34px !important;
  width: 64px !important;
}

.createBtn {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: 64px !important;
}

.snackBar1 {
  color: green !important;
}
</style>
